import React, {Component} from 'react'
import PropTypes from "prop-types";


class TreatmentCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      /*  if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }*/
    }

    componentDidMount() {
    }

    editTreatmentPlan = (func,value,index) => {
        this.props.editTreatmentPlan(func,value,index)
        this.props.changeView(3)

    }

    render() {
        let {entry} = this.state
        let {t}=this.props
        let currentEntry= this.props.current


        let category=[
            "T3/C15","T5/C10",
            "T10/C2","T10/C10","T15/C3",
             "T5/C5"]

        let categoryFlower = [
            "T0/C26",  "T1/C22", "T3/C18", "T3/C12", "T12/C12",
            "T8/C8", "T1/C1", "T12/C2", "T18/C3", "T22/C4"]

        let categoryOil = [
            "T0/C30","T1/C20","T1/C28", "T1/C24", "T3/C18", "T3/C12", "T12/C12", "T8/C8", "T3/C3", "T1/C1", "T12/C2", "T18/C3", "T22/C4"]

        if(currentEntry['TreatmentIntakeMethod'] === "Flower"){
            categoryFlower.map(item => category.push(item))
        }else if(currentEntry['TreatmentIntakeMethod'] === "Oil drops"){
            categoryOil.map(item => category.push(item))
        }else if(currentEntry['TreatmentIntakeMethod'] === "Precision Dosing Devices"){
            category.push("T22/C4")
        }

       let categoriesArr= category.map(item=> {
           return <div
               className={currentEntry.TreatmentCategory === item ? "select-method-option-selected" : "select-method-option"}
               onClick={(event) => this.editTreatmentPlan("TreatmentCategory", item, this.props.index)}>
               {item}</div>
       })


        return (
            <div style={{display: this.props.view === 2 ? 'block' : 'none'}}>
                <div className={"treatment-plan-boxes-title"}> {t('patient_boarding.Category')}</div>
                <div className={"select-method-options"}>
                    {categoriesArr}
            </div>
{/*
             <div className={"select-method-options"}>
                <div className={currentEntry.TreatmentCategory ==="T10/C10" ? "select-method-option-selected" :"select-method-option" }
                     onClick={(event) => this.editTreatmentPlan("TreatmentCategory", "T10/C10",this.props.index)}>
                    T10/C10</div>
                <div className={currentEntry.TreatmentCategory ==="T15/C3" ? "select-method-option-selected" :"select-method-option" }
                     onClick={(event) => this.editTreatmentPlan("TreatmentCategory", "T15/C3",this.props.index)}>
                    T15/C3</div>
                <div className={currentEntry.TreatmentCategory ==="T20/C4" ? "select-method-option-selected" :"select-method-option" }
                     onClick={(event) => this.editTreatmentPlan("TreatmentCategory", this.props.index)}>
                    T20/C4</div>
                <div className={currentEntry.TreatmentCategory ==="T5/C5" ? "select-method-option-selected" :"select-method-option" }
                     onClick={(event) => this.editTreatmentPlan("TreatmentCategory", "T5/C5",this.props.index)}>
                    T5/C5</div>
                 {currentEntry.TreatmentIntakeMethod !== "Flower" && <div
                     className={currentEntry.TreatmentCategory === "T1/C28" ? "select-method-option-selected" : "select-method-option"}
                     onClick={(event) => this.editTreatmentPlan("TreatmentCategory", "T1/C28", this.props.index)}>
                     T1/C28</div>}
              </div>
*/}

            </div>

        )
    }
}

TreatmentCategory.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TreatmentCategory;
